export const PROPERTY_BLOCK = (communityId: string) => `v1/property-blocks/community/${communityId}`;
export const PROPERTY_BLOCK_WITHOUT_COMMUNITY = `v1/property-blocks`;
